// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Wi-z","breadcrumbItem":"Xi-z","hideOnMobile":"Yi-z"};